/**
 * We load currencies here instead of from CLDR because CLDR loads all of them at once and we don't need that much data
 */
const pick = require('lodash').pick;
const currencies = require('cldr-data/main/en/currencies').main.en.numbers.currencies;

const supported = [
  'AUD',
  'BRL',
  'CAD',
  'CNY',
  'EUR',
  'GBP',
  'HKD',
  'IDR',
  'JPY',
  'KRW',
  'TWD',
  'USD',
];

module.exports = {
  // from /node_modules/cldr-data/main/en/currencies.json
  main: {
    en: {
      numbers: {
        currencies: pick(currencies, supported)
      }
    }
  }
};
